import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Breadcrumbs as MuiBreadcrumbs,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import Sidebar from "./Sidebar";
import Footer from "./Footer";

// page components
import Dashboard from "./AdminPages/Dashboard";
import Orders from "./AdminPages/Orders";
import PendingOrders from "./AdminPages/submenu/PendingOrders";
import CompletedOrders from "./AdminPages/submenu/CompletedOrders";
import Requests from "./AdminPages/Requests";
import AdminPage from "../../pages/AdminPage";
import Upload from "./AdminPages/Upload";
import UserRequest from "./AdminPages/submenu/UserRequest";

import userManagement from "./AdminPages/UserManagement";
// import UserManagement from "./AdminPages/UserManagement";



import { Tooltip as ReactTooltip } from "react-tooltip";
import './admin.scss';

//
import { useTheme, useMediaQuery } from "@mui/material";
import UserManagement from "./AdminPages/UserManagement";
import ModelManagement from "./AdminPages/ModelManagement";
import ScreenManagement from "./AdminPages/ScreenManagement";
import CompanyOnboarding from "./AdminPages/CompanyOnboarding";
import { useAppLogo } from "../../hooks/useAppLogo";
//

const drawerWidth = 240;
const collapsedWidth = 64;



type PageKey =
  | "userRequest"
  | "requests"
  | "upload"
  | "companyOnboarding"
  | "userManagement"
  | "modelManagement"
  | "screenManagement";

  const AdminLayout: React.FC = () => {
  const [selectedPage, setSelectedPage] = useState<PageKey>("userRequest");
  const [collapsed, setCollapsed] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);


  //
const theme = useTheme();
const isMobile = useMediaQuery(theme.breakpoints.down('md'));
const [mobileOpen, setMobileOpen] = useState(false);
  //

  const tmpUsername: any = localStorage.getItem("userId");
  const tmpDomaiName: any = localStorage.getItem("domain");
  const storedImageUrl = localStorage.getItem("profileImage");
  const appLogo = useAppLogo();

  // let userImg1: any =
  //   "https://oneappscoreservice.motherson.com/GlobalApps/GetUserProfilePicture?userid=" +
  //   tmpDomaiName?.toLocaleUpperCase() +
  //   "\\" +
  //   tmpUsername;

  const renderContent = () => {
    switch (selectedPage) {
      // case "dashboard":
      //   return <Dashboard />;
      // case "orders":
      //   return <Orders />;
      // case "orders/pending":
      //   return <PendingOrders />;
      // case "orders/completed":
      //   return <CompletedOrders />;
        case "userRequest":
        return <UserRequest />  ;
        case "requests":
        return <AdminPage />  ;
        case "upload":
        return <Upload />  ;
        case "companyOnboarding":
        return <CompanyOnboarding />  ;
        case "userManagement":
        return <UserManagement/>;

        case "modelManagement":
        return <ModelManagement/>  ;

        case "screenManagement":
        return <ScreenManagement />;



      default:
        return <UserRequest />;
    }
  };

  const currentLabel: Record<PageKey, string> = {
    // dashboard: "Dashboard",

    userRequest: "User Request",
    requests: "Model Requests ",
    upload: "Upload Documents",
    companyOnboarding: "Company Onboarding",
    userManagement: "User Management",
    modelManagement: "Model Management",
    screenManagement: "Screen Management",

    // orders: "Orders",
    // "orders/pending": "Pending Orders",
    // "orders/completed": "Completed Orders",
  };

  return (
    <Box sx={{ display: "flex" }} className="admin-body-layout">
      <AppBar className="admin_header" position="fixed" sx={{ zIndex: (t) => t.zIndex.drawer + 1 }}>
        <Toolbar>
          <div className="leftSection">
          <IconButton
            edge="start"
            color="inherit"
            // onClick={() => setCollapsed(!collapsed)}
            onClick={() => {
              if (isMobile) {
                setMobileOpen(!mobileOpen);
              } else {
                setCollapsed(!collapsed);
              }
            }}
            //
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            {/* Admin Panel */}
            {appLogo ? (
              <img src={appLogo} alt="Lipi logo" className="admin-app-logo" />
            ) : (
              <svg
            width="42"
            height="24"
            viewBox="0 0 58 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path id="logopath1"
              d="M55.0589 4.27963C54.4429 4.27963 53.9133 4.0797 53.4702 3.67984C53.0379 3.27997 52.8218 2.77204 52.8218 2.15603C52.8218 1.54002 53.0379 1.02668 53.4702 0.616008C53.9133 0.205336 54.4429 0 55.0589 0C55.6965 0 56.2368 0.205336 56.6799 0.616008C57.123 1.02668 57.3446 1.54002 57.3446 2.15603C57.3446 2.73961 57.123 3.24215 56.6799 3.66363C56.2368 4.0743 55.6965 4.27963 55.0589 4.27963ZM56.9231 22.4843C56.9231 23.5228 56.0812 24.3647 55.0426 24.3647C54.0041 24.3647 53.1622 23.5228 53.1622 22.4843V9.64539C53.1622 8.60684 54.0041 7.76494 55.0426 7.76494C56.0812 7.76494 56.9231 8.60684 56.9231 9.64538V22.4843Z"

            />
            <path id="logopath2"
              d="M37.2763 21.3745C37.2683 21.3616 37.2541 21.3535 37.2389 21.3535C37.2148 21.3535 37.1952 21.3731 37.1952 21.3973V30.0221C37.1952 31.1145 36.3096 32 35.2173 32C34.1249 32 33.2393 31.1144 33.2393 30.0221V8.38873C33.2393 7.29634 34.1249 6.4108 35.2173 6.4108H35.6547C36.5055 6.4108 37.1952 7.1005 37.1952 7.95128V9.44848C37.1952 9.47239 37.2146 9.49177 37.2385 9.49177C37.2539 9.49177 37.2682 9.48341 37.276 9.47009C38.6284 7.1567 40.6021 6 43.1972 6C45.4138 6 47.1417 6.78165 48.3807 8.34496C49.6198 9.90827 50.2393 12.0079 50.2393 14.6438C50.2393 17.5651 49.5402 19.9043 48.142 21.6616C46.7438 23.4189 44.8341 24.2976 42.4128 24.2976C40.1928 24.2976 38.4806 23.3232 37.2763 21.3745ZM37.1611 14.4384V16.6122C37.1611 17.8903 37.5646 18.9743 38.3717 19.8644C39.1902 20.7544 40.2246 21.1995 41.475 21.1995C42.9414 21.1995 44.0895 20.6289 44.9194 19.4878C45.7605 18.3353 46.1811 16.7321 46.1811 14.6781C46.1811 12.955 45.789 11.6085 45.0046 10.6386C44.2316 9.65723 43.1801 9.16656 41.8502 9.16656C40.4406 9.16656 39.3038 9.66864 38.4399 10.6728C37.5874 11.677 37.1611 12.9322 37.1611 14.4384Z"
              fill="#0D0D0D"
            />
            <path id="logopath3"
              d="M25.9636 23.0058C25.9623 22.9454 25.9369 22.8879 25.8925 22.8452C25.8481 22.8025 25.7882 22.778 25.7254 22.7768L18.6226 22.7775C18.617 22.7775 18.6123 22.7745 18.6067 22.7745C18.5738 22.7726 18.5413 22.767 18.5098 22.7577C18.4886 22.7538 18.4678 22.7484 18.4475 22.7413C18.418 22.7269 18.3904 22.7091 18.3653 22.6882C18.3486 22.6776 18.3327 22.6659 18.3177 22.6531C18.2957 22.6284 18.2766 22.6014 18.2609 22.5726C18.2503 22.5569 18.2407 22.5406 18.2324 22.5237C18.2296 22.5172 18.222 22.5138 18.2212 22.5054L16.095 16.4468C15.987 16.0827 15.9708 15.699 16.0478 15.3277C16.1248 14.9563 16.2927 14.608 16.5376 14.3114L21.3062 8.54369C21.4474 8.37108 21.6283 8.2322 21.8346 8.13792C22.0409 8.04364 22.2671 7.99651 22.4956 8.0002L22.4979 8.00249L22.5003 8.0002L22.5087 8.00211C22.7074 7.99972 22.9047 8.03565 23.0888 8.10775C23.2729 8.17986 23.4401 8.28669 23.5805 8.42194C23.6215 8.46137 23.6601 8.50304 23.696 8.54675L28.4638 14.313C28.7101 14.6124 28.8782 14.9642 28.9541 15.3389C29.03 15.7136 29.0115 16.1003 28.9001 16.4667L27.8977 19.3235C27.8803 19.3742 27.8527 19.4211 27.8163 19.4615C27.78 19.5019 27.7357 19.535 27.6861 19.5588C27.6364 19.5827 27.5823 19.5969 27.5269 19.6006C27.4715 19.6043 27.4159 19.5974 27.3632 19.5803C27.3106 19.5632 27.262 19.5363 27.2202 19.5011C27.1785 19.4659 27.1444 19.4231 27.1199 19.3752C27.0954 19.3273 27.081 19.2752 27.0776 19.2219C27.0741 19.1686 27.0817 19.1152 27.0998 19.0647L28.0962 16.2259C28.1674 15.9856 28.1781 15.7326 28.1273 15.4876C28.0766 15.2426 27.9659 15.0128 27.8044 14.8171L23.0414 9.04787C23.007 9.00751 22.9677 8.97125 22.9243 8.93986V14.1122C23.4502 14.2126 23.9185 14.4976 24.238 14.9116C24.5575 15.3256 24.7054 15.8391 24.6529 16.3521C24.6004 16.8651 24.3513 17.3411 23.954 17.6873C23.5567 18.0335 23.0397 18.2253 22.5035 18.2253C21.9673 18.2253 21.4503 18.0335 21.053 17.6873C20.6557 17.3411 20.4066 16.8651 20.3541 16.3521C20.3016 15.8391 20.4495 15.3256 20.769 14.9116C21.0885 14.4976 21.5568 14.2126 22.0827 14.1122L22.0823 8.93872C22.0391 8.97068 22.0004 9.00788 21.9672 9.0494L17.1978 14.8141C17.0377 15.0072 16.9273 15.2339 16.8758 15.4758C16.8243 15.7177 16.833 15.968 16.9013 16.206L18.9259 21.9692L25.727 21.9669C25.8688 21.9668 26.0092 21.9935 26.1402 22.0456C26.2712 22.0977 26.3903 22.1742 26.4905 22.2706C26.5908 22.367 26.6703 22.4814 26.7245 22.6074C26.7787 22.7333 26.8065 22.8683 26.8064 23.0046L26.8068 24.9599C26.8067 25.2352 26.6929 25.4992 26.4904 25.6939C26.2879 25.8885 26.0134 25.9979 25.727 25.998L16.8519 25.9999C16.796 26.0009 16.7405 25.9911 16.6885 25.9712C16.6366 25.9513 16.5893 25.9217 16.5494 25.884C16.5095 25.8464 16.4778 25.8015 16.4562 25.7519C16.4345 25.7023 16.4233 25.6491 16.4233 25.5954C16.4233 25.5416 16.4344 25.4884 16.456 25.4388C16.4776 25.3892 16.5092 25.3443 16.5491 25.3066C16.589 25.2689 16.6362 25.2392 16.6881 25.2193C16.7401 25.1993 16.7956 25.1895 16.8515 25.1904L25.7266 25.19C25.7579 25.1902 25.789 25.1844 25.818 25.1729C25.8469 25.1615 25.8733 25.1446 25.8954 25.1233C25.9176 25.102 25.9351 25.0767 25.947 25.0489C25.9589 25.021 25.965 24.9912 25.9648 24.961L25.9636 23.0058ZM21.575 17.0354C21.7586 17.2119 21.9926 17.3322 22.2473 17.3809C22.502 17.4296 22.7661 17.4046 23.006 17.309C23.246 17.2135 23.4511 17.0517 23.5953 16.8441C23.7396 16.6364 23.8167 16.3924 23.8167 16.1427C23.8167 15.893 23.7396 15.6489 23.5953 15.4413C23.4511 15.2336 23.246 15.0718 23.006 14.9763C22.7661 14.8807 22.502 14.8557 22.2473 14.9044C21.9926 14.9531 21.7586 15.0734 21.575 15.2499C21.329 15.4868 21.1908 15.8079 21.1908 16.1427C21.1908 16.4774 21.329 16.7985 21.575 17.0354Z"
              fill="#DA2128"
              stroke="#DA2128"
              stroke-width="0.9"
            />
            <circle id="logopathcircle" cx="23.2471" cy="2.24705" r="2.24705" fill="#DA2128" />
            <path id="logopath5"
              d="M14 25.2513C14 26.2171 13.2171 27 12.2513 27H2C0.895431 27 0 26.1046 0 25V2C0 0.895431 0.895431 0 2 0H2.19647C3.30104 0 4.19647 0.895431 4.19647 2V21.5026C4.19647 22.6071 5.0919 23.5026 6.19647 23.5026H12.2513C13.2171 23.5026 14 24.2855 14 25.2513Z"
              fill="#0D0D0D"
            />
          </svg>
            )}
          </Typography>
          </div>

          <button
            id="basic-button"
            className="userIconBtn"
            data-tooltip-id="userProfile"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            {storedImageUrl ? (
              <img src={storedImageUrl} alt="User" />
            ) : (
              <div className="user-initial">
                {tmpUsername?.charAt(0).toUpperCase()}
              </div>
            )}
          </button>
        </Toolbar>
      </AppBar>

      <Sidebar
        // collapsed={collapsed}
        // selectedPage={selectedPage}
        // onSelect={(key) => setSelectedPage(key as PageKey)}
        collapsed={collapsed}
        selectedPage={selectedPage}
        onSelect={(key) => setSelectedPage(key as PageKey)}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        isMobile={isMobile}
      />

      <Box
        className="admin-body-wrapper" style={{position:"relative"}}
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          mt: 8,
          display: "flex",
          flexDirection: "column",
          minHeight: `calc(100% - 3rem)`,
          // minHeight: "100%",
          width: `calc(100% - ${collapsed ? collapsedWidth : drawerWidth}px)`,
          transition: "width 0.3s",
        }}
      >
        <MuiBreadcrumbs sx={{ mb: 2 }} className={
              selectedPage ? currentLabel[selectedPage].replace(' ', '') : 'default-class'
            }>
          <Typography color="text.primary" 
          
          >
            {currentLabel[selectedPage]}
          </Typography>
          
        </MuiBreadcrumbs>

        <ReactTooltip
          className="customTooltip"
          id="userProfile"
          place="bottom"
          content="User"
        />

        <Box sx={{ flexGrow: 1 }}>{renderContent()}</Box>

        <Footer />
      </Box>
    </Box>
  );
};

export default AdminLayout;
